import { render, staticRenderFns } from "./InlineTooltipQuestion.vue?vue&type=template&id=3b889a68&"
import script from "./InlineTooltipQuestion.vue?vue&type=script&lang=ts&"
export * from "./InlineTooltipQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports